/* global document */
import inDOM from 'dom-helpers/util/inDOM';
import round from '../helpers/round';

const unit = 'px';
const step = 2;
export const keys = ['sm', 'md', 'lg', 'xl', 'xxl'];
export const values = {
  sm: 0,
  md: 768, // to match existing settings on theiconic.com.au
  lg: 960,
  xl: 1280,
  xxl: 1440,
};

export const wideMobile = 360;

function upValue(key) {
  return typeof values[key] === 'number' ? values[key] : key;
}

export function up(key) {
  return `@media (min-width: ${upValue(key)}${unit})`;
}

function downValue(key) {
  const endIndex = keys.indexOf(key) + 1;
  const upperbound = values[keys[endIndex]];
  return typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
}

export function down(key) {
  if (keys.indexOf(key) === keys.length - 1) {
    // xl down applies to all sizes
    return up('sm');
  }
  return `@media (max-width: ${downValue(key) - step / 100}${unit})`;
}

export function between(start, end) {
  if (keys.indexOf(end) === keys.length - 1) {
    return up(start);
  }

  return (
    `@media (min-width: ${upValue(start)}${unit}) and `
        + `(max-width: ${downValue(end) - step / 100}${unit})`
  );
}

export function only(key) {
  return between(key, key);
}

export function width(key) {
  return values[key];
}

export function current() {
  const viewportWidth = inDOM ? document.documentElement.clientWidth : 0;
  for (let i = keys.length - 1; i > 0; i -= 1) {
    const bp = keys[i];
    if (values[bp] <= viewportWidth) {
      return bp;
    }
  }
  return keys[0];
}

export const upscaled = (initialSize, breakpoint = 'xxl') => (
  `${round(100 * initialSize / width(breakpoint))}vw`
);
